import { render, staticRenderFns } from "./ReadHistory.vue?vue&type=template&id=e485ae0e&"
import script from "./ReadHistory.vue?vue&type=script&lang=js&"
export * from "./ReadHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports